import TheTypewriter from './theTypewriter/TheTypewriter'
import TheBookcase from './TheBookcase'
import TheButtons from './theButtons/TheButtons'
import TheFilingCabinet from './theFilingCabinet/TheFilingCabinet'
import TheVoiceRecorder from './TheVoiceRecorder'
import TheCertificate from './TheCertificate'
import TheTelephone from './theTelephone/TheTelephone'
import TheLockedDrawer from './TheLockedDrawer'

import typewriterSolution from '../../../../images/clues/office/typewriterSolution.png'
import buttonsSolution from '../../../../images/clues/office/buttonsSolution.png'
import voiceRecorderSolution from '../../../../images/clues/office/voiceRecorderSolution.png'



const officeData = [
    {
        name: 'The Typewriter',
        id: 'typewriter',
        sceneText: "A typewriter. Useful for typing",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheTypewriter />,
        cluesAvailable: true,
        clues: [
            {
                text: "There is something on page 2 which will help with the typewriter."
            },
            {
                text: 'Can you make the arrows meet each other on page 2?'
            },
            {
                text: 'Fold page 2 so that the arrows meet. When you do this you will be able to see a word. The next hint will be the solution.'
            },
            {
                text: 'Folding the page will give you the word BREADCRUMB. Use this in the typewriter.',
                image: typewriterSolution
            }
        ]
    },
    {
        name: 'The Bookcase',
        id: 'bookcase',
        sceneText: "Everything I learned, I read it in a book",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheBookcase />,
        cluesAvailable: false
    },
    {
        name: 'The Buttons',
        id: 'buttons',
        sceneText: "A hidden button panel! Intriguing...",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheButtons />,
        cluesAvailable: false,
        clues: [
            {
                text: 'These buttons are labelled on page 15. Can you find anything in the office to tell you which buttons to press?',
            },
            {
                text: 'Page 15 tells you that each button represents a letter in the word WONDER.Now check out the books on the bookcase.'
            },
            {
                text: 'Each book has a different letter highlighted. Pay close attention to the volume numbers of the books for the order. The next hint will be the solution.'
            },
            {
                text: 'Press the buttons in the following order: NODERW',
                image: buttonsSolution
            }
        ]
    },
    {
        name: 'The Filing Cabinet',
        id: 'filing',
        sceneText: "Everything filed away in it's proper place",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheFilingCabinet />,
        cluesAvailable: false
    },
    {
        name: 'The Voice Recorder',
        id: 'voiceRecorder',
        sceneText: "The bookcase has moved to reveal a voice recorder",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheVoiceRecorder />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Listen to the voice recording carefully. Can you use what the Professor is saying to help with the filing cabinet?'
            },
            {
                text: 'The professor talks about furniture in his office. In the filing cabinet there is a floorplan. Need help identifying the furniture? Turn to page 5.'
            },
            {
                text: "Remember when clicking on the floorplan that the professor's left and right is from his point of view based on where he is standing and looking. The next hint will be the solution."
            },
            {
                text: 'Click on the floorplan furniture in this order: COAT STAND - PLANT - LEFT OF CHALKBOARD - RIGHT OF BOOKCASE - DESK CHAIR.',
                image: voiceRecorderSolution
            }
        ]
    },
    {
        name: 'The Certificate',
        id: 'certificate',
        sceneText: "The Professor is very clever",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheCertificate />,
        cluesAvailable: false,
        clues: [
            {
                text: "Page 13 has the same symbol as the certificate. Can you use page 13 to decode the professor's notes on his certificate?"
            },
            {
                text: 'On page 13, read the letters from top to bottom. Reading in this way will give you a selection of words and their corresponding 2 digits.'
            },
            {
                text: "The first note on the certificate is [performance]. On page 13 the word 'SHOW' has the two digits 62. Can you use this method to work out the other 4 digits? The next hint will be the solution."
            },
            {
                text: 'The certificate notes translate to: SHOW 62, GONE 26, ECHO 47. Use the code 622647 in the telephone.'
            }
        ]
    },
    {
        name: 'The Telephone',
        id: 'telephone',
        sceneText: "**ring-ring** **ring-ring**",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheTelephone />,
        cluesAvailable: false
    },
    {
        name: 'The Locked Drawer',
        id: 'drawer',
        sceneText: "This drawer is locked. It needs a key.",
        specialIcon: 'fas fa-lock',
        puzzleVisible: true,
        puzzleLocked: true,
        component: <TheLockedDrawer finalPuzzle />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Click on the key in your inventory and select the padlock icon in the office to use the key.'
            }
        ]
    }
]

export default officeData